<template>
  <WheelSlider
    :list="[
      { perspective: 'center', items: feet, ref: 'feet', selectedIndex: feetIndex },
      { perspective: 'center', items: inches, ref: 'inches', selectedIndex: inchesIndex },
    ]"
    @on-change="handleChange"
  />
</template>

<script>
import WheelSlider from '@/components/base/WheelSlider'

export default {
  name: 'Height',
  components: { WheelSlider },
  props: {
    minFeet: {
      type: Number,
      default: 3,
    },
    maxFeet: {
      type: Number,
      default: 8,
    },
    minInches: {
      type: Number,
      default: 0,
    },
    maxInches: {
      type: Number,
      default: 11,
    },
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      feet: Array.from({ length: this.maxFeet - this.minFeet + 1 }, (_, i) => ({
        label: `${this.minFeet + i}'`,
        value: this.minFeet + i,
      })),
      inches: Array.from({ length: this.maxInches - this.minInches + 1 }, (_, i) => ({
        label: `${i}"`,
        value: i,
      })),
      localHeight: { feet: 5, inches: 0 },
    };
  },
  computed: {
    feetIndex() {
      return this.localHeight.feet - this.minFeet;
    },
    inchesIndex() {
      return this.localHeight.inches;
    },
    parsedHeight() {
      // If value is empty, return default height
      if (this.value.length !== 1) {
        const [feetStr, inchesStr] = String(this.value).split("'");
        const feet = parseInt(feetStr, 10);
        const inches = parseInt(inchesStr, 10);
        return { feet, inches };
      }
      return { feet: this.localHeight.feet || this.minFeet, inches: this.localHeight.inches || this.minInches };
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.localHeight = this.parsedHeight;
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(newHeight) {
      const updatedHeight = { ...this.localHeight };
      if (newHeight.ref === 'feet') {
        updatedHeight.feet = newHeight.selectedValue.value;
      }
      if (newHeight.ref === 'inches') {
        updatedHeight.inches = newHeight.selectedValue.value;
      }

      this.localHeight = updatedHeight;
      this.$emit('input', `${updatedHeight.feet}'${updatedHeight.inches}"`);
    },
  },
};
</script>